

export const tedReviewerReviewHinge = {
  _id: 'tedReviewerReviewHingeId',
  email: 'ted@email.com',
  profileReviewId: 'tedProfileReviewHingeId',
  reviewerProfileId: 'tedReviewerProfileId',
  starRating: 5,
  reviewText: 'Thanks so much for the review Ted! This will really help me!',
  profileReviewedFirstName: 'Robin',
}

export const tedReviewerReviewBumble = {
  _id: 'tedReviewerReviewBumbleId',
  email: 'ted@email.com',
  profileReviewId: 'tedProfileReviewBumbleId',
  reviewerProfileId: 'tedReviewerProfileId',
  starRating: 5,
  reviewText: 'Thanks so much for the review Ted! This will really help me!',
  profileReviewedFirstName: 'Robin',
}

export const barneyReviewerReviewTinder = {
  _id: 'barneyReviewerReviewTinderId',
  email: 'barney@email.com',
  profileReviewId: 'barneyProfileReviewTinderId',
  reviewerProfileId: 'barneyReviewerProfileId',
  starRating: 5,
  reviewText: 'Thanks so much for the review Barney! This will really help me!',
  profileReviewedFirstName: 'Robin',
}